export const StatusBadge = ({ status, label }) => {
  const styles = {
    order_received: "bg-sky-50 text-sky-700 border-sky-200",
    in_production: "bg-amber-50 text-amber-700 border-amber-200",
    ready_to_dispatch: "bg-cyan-50 text-cyan-700 border-cyan-200",
    dispatched: "bg-indigo-50 text-indigo-700 border-indigo-200",
    delivered: "bg-emerald-50 text-emerald-700 border-emerald-200",
  };
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium whitespace-nowrap ${styles[status] || "bg-slate-50 text-slate-700 border-slate-200"}`}
    >
      {label}
    </span>
  );
};

export const AgingBadge = ({ color, days }) => {
  if (color === "none")
    return <span className="text-xs text-slate-400">{days}d cycle</span>;
  const styles = {
    green: "bg-[#ECFDF5] text-[#047857] border-[#A7F3D0]",
    yellow: "bg-[#FFFBEB] text-[#B45309] border-[#FDE68A]",
    red: "bg-[#FEF2F2] text-[#B91C1C] border-[#FECACA]",
  };
  return (
    <span
      data-testid={`aging-badge-${color}`}
      className={`inline-flex items-center gap-1.5 rounded-md border px-2 py-0.5 text-xs font-semibold whitespace-nowrap ${styles[color]}`}
    >
      <span className={`aging-dot ${color}`} />
      {days}d
    </span>
  );
};

export const RoleBadge = ({ role }) => {
  const labels = { sales: "Sales", sales_lead: "Sales Lead", production: "Production", dispatch: "Dispatch", admin: "Admin / Accounts", customer: "Customer" };
  return (
    <span className="inline-flex items-center rounded-md border border-slate-200 bg-slate-50 px-2 py-0.5 text-xs font-medium uppercase tracking-wide text-slate-600">
      {labels[role] || role}
    </span>
  );
};
